import './FlyoutRoster.css';

import { FlyoutPlanContext } from './flyout-plan-context.js';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import React from 'react';

FlyoutRoster.propTypes = {
  flyout: PropTypes.object.isRequired,
  onRegister: PropTypes.func,
  selectedPlaneId: PropTypes.string,
  onSelectPlane: PropTypes.func
};

export default function FlyoutRoster({ flyout, onRegister, selectedPlaneId, onSelectPlane }) {
  const { allPlans } = useContext(FlyoutPlanContext);
  const simState = useSelector(state => state.sim);
  const planesState = useSelector(state => state.planes);
  const selectedPlane = useSelector(state => state.planes[selectedPlaneId]);
  const isSimulating = simState.mode === "RUNNING";

  function isPlaneInDistress(planeReg) {
    const planeState = planesState[planeReg];
    return planeState?.distress;
  }

  function getPlaneStatus(planeReg) {
    const plan = allPlans.find(plan => plan.plane.reg === planeReg);
    
    if (!plan) {
      return 'available';
    }

    if (isPlaneInDistress(planeReg)) {
      return 'distress';
    }

    const currentDay = plan.days[0];
    const flightLegs = currentDay.legs.filter(leg => leg.type === 'flight');
    const lastFlightLeg = flightLegs[flightLegs.length - 1];
    
    if (lastFlightLeg && 
        lastFlightLeg.segments[lastFlightLeg.segments.length - 1].to.code === currentDay.endPoint.code) {
      return 'ready';
    }
    
    return 'planning';
  }

  function getLatestLogMessage(planeReg) {
    const planeLog = simState.planeLog[planeReg];
    if (!planeLog || planeLog.length === 0) return null;
    return planeLog[planeLog.length - 1];
  }

  function handleRowClick(planeReg) {
    if (onSelectPlane) {
      if (selectedPlaneId === planeReg) {
        onSelectPlane(null);
      } else {
        onSelectPlane(planeReg);
      }
    }
  }

  return (
    <table className="flyout-roster">
      <tbody>
        {flyout && flyout.planes.map((plane, index) => (
          <React.Fragment key={`plane-${index}`}>
            <tr className={selectedPlaneId === plane.reg ? 'selected' : ''} onClick={() => handleRowClick(plane.reg)}>
              <td className="chevron-cell">
                <svg className="chevron-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 18l6-6-6-6" strokeWidth="4" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </td>
              <td>
                <div className={`flyout-roster-plane-status ${getPlaneStatus(plane.reg)}`} 
                    title={getPlaneStatus(plane.reg)} />
              </td>
              <td className="flyout-roster-plane-details">{plane.reg}</td>
              <td className="flyout-roster-plane-details">{plane.type}</td>
              <td className="flyout-roster-plane-details">PoB: {plane.PoB}</td>
              <td className="flyout-roster-plane-details">
                {getPlaneStatus(plane.reg) === 'available' && 
                  <button 
                    className="flyout-signup-button" 
                    onClick={(e) => {
                      e.stopPropagation();
                      onRegister(plane);
                    }}
                  >Join</button>
                }
              </td>
            </tr>
            {isSimulating && getLatestLogMessage(plane.reg) && (
              <tr className="log-entry">
                <td></td><td></td>
                <td colSpan="4">
                  {getLatestLogMessage(plane.reg).text}
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )
}
